export default {
    rowSelection: false,
  // toolbar: false,
    fieldControl: false,
    pagination: false,
    title: '合同信息',
    columns: [
      {
        title: '承包商',
        dataIndex: 'vendorName',
        width: 180,
      },
      {
        title: '合同名称',
        dataIndex: 'name',
        width: 160,
      },
      {
        title: '合同编号',
        dataIndex: 'code',
        width: 140,
      },
      {
        title: '签订日期',
        dataIndex: 'signDate',
        itemType: 'date',
        width: 120,
      },
      {
        title: '有效期',
        dataIndex: 'contratTime',
        width: 180,
        render: 'setContratTime',
      },
      {
        title: '状态',
        dataIndex: 'statusName',
        width: 100,
      },
      {
        title: '类型',
        dataIndex: 'typeName',
        width: 140,
      },
      {
        title: '操作',
        dataIndex: 'actionTool',
        width: 100,
        render: 'actionTool',
        fixed: 'right',
      },
    ],
    search: [],
  footer: [
    // {
    //   label: "新增",
    //   type: "primary",
    //   events: ["onClick:contractModel"]
    // },
  ],
  };
